import { useContext } from "react"
import * as topBannerActions from "../context/TopBanner/actions"
import { TopBannerContext } from "../context/TopBanner/context"

export const useTopBannerContext = () => {
	const [state, dispatch] = useContext(TopBannerContext)

	return { ...state, dispatch, ...topBannerActions }
}
